import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import NavBar from '../components/nav/Nav';
import Footer from '../components/footer/Footer';

import intro from '../assets/img/flotas-intro.jpg';
import outro from '../assets/img/flotas-outro.jpg';
import outro2 from '../assets/img/flotas-outro-2.jpg';
import card1 from '../assets/img/flotas-1.jpg';
import card2 from '../assets/img/flotas-2.jpg';
import card3 from '../assets/img/flotas-3.jpg';

const Flotas = () => {
    
    const navigate = useNavigate();
    
    const [animationNav, setAnimationNav] = useState('move');
    const [animationFooter, setAnimationFooter] = useState(null);
    const [animationContent, setAnimationContent] = useState('fade');

    const handleNavButtonClick = async () => {
        setAnimationContent('fade-away');
        await new Promise(resolve => setTimeout(resolve, (300)));
        setAnimationFooter('away-move');
        await new Promise(resolve => setTimeout(resolve, (100)));
        setAnimationNav('move-away');
        await new Promise(resolve => setTimeout(resolve, (300)));
        window.scrollTo(0, 0);
    };

    const handleFooterButtonClick = async () => {
        setAnimationContent('fade-away')
        await new Promise(resolve => setTimeout(resolve, (300)));
        setAnimationNav('move-away');
        await new Promise(resolve => setTimeout(resolve, (100)));
        setAnimationFooter('away-move');
        await new Promise(resolve => setTimeout(resolve, (300)));
        window.scrollTo(0, 0);
    };

    const handleMenuButtonClick = async (redirect) => {
        handleNavButtonClick();
        await new Promise(resolve => setTimeout(resolve, (1000)));
        navigate(redirect);
    };

    const [opa, setOpa] = useState(0);
    const [isNavHidden, setIsNavHidden] = useState(false);
    const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            setOpa(opa + 0.1);
            if (prevScrollPos > currentScrollPos) {
                if (isNavHidden || window.scrollY < 1) {
                    navBar.style.transform = 'translateY(0)';
                    setIsNavHidden(false);
                }
            } else {
                if (!isNavHidden && window.innerWidth > 800 && window.scrollY > 1) {
                    navBar.style.transform = 'translateY(-100%)';
                    setIsNavHidden(true);
                }
            }
            setPrevScrollPos(currentScrollPos);
        };

        const navBar = document.querySelector('nav');
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isNavHidden, prevScrollPos,]);

    return (
        <div id="flotas" className="w-full">
            <nav className={`${animationNav} w-full b-black`}>
                <NavBar actual={3} onNavButtonClick={handleNavButtonClick} />
            </nav>
            <div id="flotas-content" className={`${animationContent} w-full flex flex-col items-center bg-neutral-50 overflow-hidden`}>
                <Link id="whatsapp-fixed" target="_blank" to="https://wa.me/541133573254" style={{ opacity: opa }}>
                    <svg viewBox="0 0 48 48">
                        <path fill="#fff" d="M4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98c-0.001,0,0,0,0,0h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303z"></path><path fill="#fff" d="M4.868,43.803c-0.132,0-0.26-0.052-0.355-0.148c-0.125-0.127-0.174-0.312-0.127-0.483l2.639-9.636c-1.636-2.906-2.499-6.206-2.497-9.556C4.532,13.238,13.273,4.5,24.014,4.5c5.21,0.002,10.105,2.031,13.784,5.713c3.679,3.683,5.704,8.577,5.702,13.781c-0.004,10.741-8.746,19.48-19.486,19.48c-3.189-0.001-6.344-0.788-9.144-2.277l-9.875,2.589C4.953,43.798,4.911,43.803,4.868,43.803z"></path><path fill="#cfd8dc" d="M24.014,5c5.079,0.002,9.845,1.979,13.43,5.566c3.584,3.588,5.558,8.356,5.556,13.428c-0.004,10.465-8.522,18.98-18.986,18.98h-0.008c-3.177-0.001-6.3-0.798-9.073-2.311L4.868,43.303l2.694-9.835C5.9,30.59,5.026,27.324,5.027,23.979C5.032,13.514,13.548,5,24.014,5 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974C24.014,42.974,24.014,42.974,24.014,42.974 M24.014,4C24.014,4,24.014,4,24.014,4C12.998,4,4.032,12.962,4.027,23.979c-0.001,3.367,0.849,6.685,2.461,9.622l-2.585,9.439c-0.094,0.345,0.002,0.713,0.254,0.967c0.19,0.192,0.447,0.297,0.711,0.297c0.085,0,0.17-0.011,0.254-0.033l9.687-2.54c2.828,1.468,5.998,2.243,9.197,2.244c11.024,0,19.99-8.963,19.995-19.98c0.002-5.339-2.075-10.359-5.848-14.135C34.378,6.083,29.357,4.002,24.014,4L24.014,4z"></path><path fill="#40c351" d="M35.176,12.832c-2.98-2.982-6.941-4.625-11.157-4.626c-8.704,0-15.783,7.076-15.787,15.774c-0.001,2.981,0.833,5.883,2.413,8.396l0.376,0.597l-1.595,5.821l5.973-1.566l0.577,0.342c2.422,1.438,5.2,2.198,8.032,2.199h0.006c8.698,0,15.777-7.077,15.78-15.776C39.795,19.778,38.156,15.814,35.176,12.832z"></path><path fill="#fff" fill-rule="evenodd" d="M19.268,16.045c-0.355-0.79-0.729-0.806-1.068-0.82c-0.277-0.012-0.593-0.011-0.909-0.011c-0.316,0-0.83,0.119-1.265,0.594c-0.435,0.475-1.661,1.622-1.661,3.956c0,2.334,1.7,4.59,1.937,4.906c0.237,0.316,3.282,5.259,8.104,7.161c4.007,1.58,4.823,1.266,5.693,1.187c0.87-0.079,2.807-1.147,3.202-2.255c0.395-1.108,0.395-2.057,0.277-2.255c-0.119-0.198-0.435-0.316-0.909-0.554s-2.807-1.385-3.242-1.543c-0.435-0.158-0.751-0.237-1.068,0.238c-0.316,0.474-1.225,1.543-1.502,1.859c-0.277,0.317-0.554,0.357-1.028,0.119c-0.474-0.238-2.002-0.738-3.815-2.354c-1.41-1.257-2.362-2.81-2.639-3.285c-0.277-0.474-0.03-0.731,0.208-0.968c0.213-0.213,0.474-0.554,0.712-0.831c0.237-0.277,0.316-0.475,0.474-0.791c0.158-0.317,0.079-0.594-0.04-0.831C20.612,19.329,19.69,16.983,19.268,16.045z" clip-rule="evenodd"></path>
                    </svg>
                </Link>
                <div id="flotas-banner" className="w-full banner-1 flex justify-center flex-col">
                    <h2 id="flotas-banner-title" className="w-1/3 fade-delay-1 c-white poppins-600 ms-36">FLOTAS</h2>
                    <h3 id="flotas-banner-subtitle" className="w-1/3 fade-delay-1-5 c-white poppins-400 ms-36">Mantenimiento preventivo y correctivo</h3>
                </div>
                <div className="flotas-intro flex items-center">
                    <div id="flotas-intro-img-container" className="w-1/3 bg-red-600 fade-delay-right-3">
                        <img src={intro} alt="img" />
                    </div>
                    <div className="flex flex-col w-2/3 fade-delay-right-3-5">
                        <h3 className="poppins-600 w-full text-red-600 uppercase">El mejor cuidado para tu flota</h3>
                        <h4 className="poppins-500 w-full">
                            Ofrecemos servicios especializados de mantenimiento preventivo y reparación
                            de flotas, asegurando que tus vehículos operen con máxima fiabilidad<span className="dn1">,
                            minimizando tiempos de inactividad y reduciendo costos operativos</span>.
                        </h4>
                    </div>
                </div>
                <div className="flotas-intro flex items-center">
                    <div id="flotas-intro-img-container" className="flotas-outro w-1/3 bg-red-600 fade-delay-right-4">
                        <img src={outro2} alt="img" />
                    </div>
                    <div className="flex flex-col w-2/3 fade-delay-right-4-5">
                        <h3 className="poppins-600 w-full text-red-600 uppercase">Servicio de Taller móvil</h3>
                        <h4 className="poppins-500 w-full">
                            Para asegurar el correcto mantenimiento de tu flota, en NR enviamos a
                            nuestros mecánicos capacitados, manteniendo tus vehículos en óptimas
                            condiciones<span className="dn2"> y garantizando la seguridad de tus empleados</span>.
                        </h4>
                    </div>
                </div>
                <div className="flotas-intro flex items-center">
                    <div id="flotas-intro-img-container" className="w-1/3 bg-red-600 fade-delay-right-5">
                        <img src={outro} alt="img" />
                    </div>
                    <div className="flex flex-col w-2/3 fade-delay-right-5">
                        <h3 className="poppins-600 w-full text-red-600 uppercase">Atención y compromiso</h3>
                        <h4 className="poppins-500 w-full">
                            Entendemos la importancia de que tu flota de vehículos se mantenga en
                            óptimas condiciones<span className="dn2">, garantizando el éxito y la eficiencia de tu empresa</span>.
                            Por eso, nos enfocamos en brindarte las soluciones que necesitas.
                        </h4>
                    </div>
                </div>
                <div className="bg-neutral-100 w-full fade-delay-right-5">
                    <div id="flotas-section-2" className="w-full flex flex-col items-center">
                        <h3 className="w-100 poppins-600 w-full c-black text-center">Nuestros Servicios Incluyen:</h3>
                        <div id="flotas-section-2-cards" className="flex">
                            <div className="flotas-card flex flex-col items-center">
                                <div className="flotas-card-img-container bg-red-600">
                                    <img src={card1} alt="card-img" />
                                </div>
                                <h4 className="poppins-600 w-full text-center text-red-600">Mantenimiento preventivo programado</h4>
                            </div>
                            <div className="flotas-card flex flex-col items-center">
                                <div className="flotas-card-img-container bg-red-600">
                                    <img src={card2} alt="card-img" />
                                </div>
                                <h4 className="poppins-600 w-full text-center text-red-600">Diagnóstico y gestión de fallas</h4>
                            </div>
                            <div className="flotas-card mb flex flex-col items-center">
                                <div className="flotas-card-img-container bg-red-600">
                                    <img src={card3} alt="card-img" />
                                </div>
                                <h4 className="poppins-600 w-full text-center text-red-600">Reparaciones mecánicas y electrónicas</h4>
                            </div>
                        </div>
                        <div id="flotas-section-2-cards" className="mb flex">
                            <div className="flotas-card flex flex-col items-center">
                                <div className="flotas-card-img-container bg-red-600">
                                    <img src={card3} alt="card-img" />
                                </div>
                                <h4 className="poppins-600 w-full text-center text-red-600">Reparaciones mecánicas y electrónicas</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="flotas-section-3" className="flex flex-col items-center bg-neutral-50">
                    <h3 className="poppins-600 w-full text-red-600 text-center">¡No dudes en contactarnos!</h3>
                    <h4 className="poppins-500 w-full text-center">
                        Ante cualquier duda o pregunta, envianos un mensaje por mail o Whatsapp y te responderemos a la brevedad. 
                    </h4>
                    <button className="w-fit border-0 text-red-600 transition duration-200 ease-in-out poppins-600 hover:text-red-500" onClick={() => handleMenuButtonClick('/contacto')}>Contacto <span className="inter-600">&gt;</span></button>
                </div>
            </div>
            <footer className={`${animationFooter} w-full`}>
                <Footer actual={3} onFooterButtonClick={handleFooterButtonClick} />
            </footer>
        </div>
    );
}

export default Flotas;